import { CustomerPreview } from 'src/frontend-common/dto/Interfaces/ICustomerPreview';
import { ScoreCluster } from 'src/dto/Score';
import { FilteredTableStructure, NavigateCallbackFn, PathToDetail } from 'src/frontend-common/dto/Interfaces/FrontendLookups';
import { Products } from 'src/frontend-common/dto/Types/ProductType';

export interface Props {
  pathToDetail: PathToDetail;
  customers: CustomerPreview[];
  isCustomersLoading: boolean;
  isCustomersError: boolean;
  tableTitle: string;
  type: 'best' | 'worst';
  navigateTo: NavigateCallbackFn;
}

export const getFetchPayload = (
  pathToDetail: PathToDetail
):
  | {
      field: string;
      product?: undefined;
    }
  | {
      field: string;
      product: Products;
    } => {
  switch (pathToDetail) {
    case 'customer':
      return {
        field: 'score_cluster',
      };
    case 'customerPhone':
      return {
        field: 'msisdn_score',
        product: 'phone',
      };
    case 'customerEmail':
      return {
        field: 'email_score',
        product: 'email',
      };
    case 'customerIpAddress':
      return {
        field: 'score',
        product: 'ip',
      };
    case 'customerDomainIntelligence':
      return {
        field: 'browser_score_cluster',
        product: 'domain',
      };
    case 'customerBotDetection':
      return {
        field: 'browser_score_cluster',
        product: 'bot-detection',
      };
  }
};

export const nameScoreCustomerTable = (pathToDetail: PathToDetail): FilteredTableStructure => ({
  tableHeaders: [
    {
      sortValue: null,
      label: 'Name',
      align: 'left',
    },
    {
      sortValue: null,
      label: 'Score',
    },
  ],
  tableBody: [
    {
      type: 'customerData',
      pathToDetail: pathToDetail,
      email: true,
    },
    {
      type: 'score',
    },
  ],
});

export const getBestAndWorst = (pathToDetail: PathToDetail, isBest: boolean, customers: CustomerPreview[]): CustomerPreview[] => {
  const valueToFilterOut = isBest ? ['very_low', 'low'] : ['very_high', 'high'];

  switch (pathToDetail) {
    case 'customer':
      return customers.filter((v) => v.score_cluster !== valueToFilterOut[0] && v.score_cluster !== valueToFilterOut[1]);
    case 'customerPhone':
      return customers.filter((v) => !(valueToFilterOut as ScoreCluster[]).includes(v.msisdn_score_cluster));
    case 'customerEmail':
      return customers.filter((v) => v.email_score_cluster && !(valueToFilterOut as ScoreCluster[]).includes(v.email_score_cluster));
    case 'customerIpAddress':
      return customers.filter((v) => v.ip_score_cluster && !(valueToFilterOut as ScoreCluster[]).includes(v.ip_score_cluster));
    case 'customerDomainIntelligence':
      return customers.filter((v) => v.domain_score_cluster && !(valueToFilterOut as ScoreCluster[]).includes(v.domain_score_cluster));
    case 'customerBotDetection':
      return customers.filter((v) => v.browser_score_cluster && !(valueToFilterOut as ScoreCluster[]).includes(v.browser_score_cluster));
  }
};
